import React from "react";
import { useNavigate } from "react-router";
import './BackButton.scss'
const BackButton = () =>
{
    const navigate = useNavigate();

    const doGoBack = (event) =>
    {
        navigate(-1) ;
    }

    return (
        <div className='back-button'>
            <button onClick={doGoBack}>Back</button>
        </div>

    );
}

export default BackButton ;
